import React from 'react';
import { PublishOutlined } from '@material-ui/icons';

class BackTop extends React.Component {
    state = {
        scrollTop : 0 
    }

    componentDidMount = () =>{
        window.addEventListener('scroll', this.handleScroll);	
    }
         
    handleScroll = () =>{
        this.setState({ scrollTop: window.scrollY });
    }

    goBackTop = () => {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }

    render() {
        return (
            <div>
            { this.state.scrollTop > 700 ? 
                <div className='back-top'>
                    <div className="back-top-content" onClick={this.goBackTop}>
                        <PublishOutlined className='publish'/>
                    </div>
                </div>
            : null}     
            </div>       
        );
    }
}

export default BackTop;
